export default () => ({
    isLoading: true,
    entries: [1,2,3]
})